import React, { useEffect, useState } from 'react';
import { OptionalExtraType } from '../Types';
import { CheckBoxContainer, Content, Header, InfoHeader, InfoLine, InfoRow, InfoText, Link } from './BookingSummaryComponents';
import moment from 'moment';
import { ConvertToPounds, getDaysArray } from '../Functions';
import CheckBoxField from '../FormGroup/CheckBoxField';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useParams } from 'react-router-dom';
import { ParamAPI } from 'API/GeneralAPI';

type BookingSummaryProps = {
    selectedDates: string[];
    totalCost: number;
}
function BookingSummary({ selectedDates, totalCost }: BookingSummaryProps) {
    const { mhid, mhname } = useParams<{ mhid: string, mhname: string }>();
    const { currentEmployee  } = useSelector((state: RootState) => state.auth);
    const { currentBooking } = useSelector((state: RootState) => state.booking);
    const [collectionTime, setCollectionTime] = useState<string>("");
    const [returnTime, setReturnTime] = useState<string>("");
    
    var collectionDate = "";
    var returnDate = "";

    if (selectedDates.length > 0) {
        collectionDate = moment(selectedDates[0]).format("DD MMM YYYY");
        returnDate = selectedDates.length > 1 ? moment(selectedDates[selectedDates.length - 1]).format("DD MMM YYYY") : "";
    }
    const discountPercentage = currentEmployee ? currentEmployee?.discount_percentage * 100 : 0;
    const days: number = getDaysArray(selectedDates[0], selectedDates[selectedDates.length -1]).length;
    const optionalExtras = currentBooking?.optional_extras;

    useEffect(() => {
            const getTimes = async () => {
                const fhCollection = await ParamAPI.get("fh_collection");
                const fhReturn = await ParamAPI.get( "fh_return");
                setCollectionTime(fhCollection);
                setReturnTime(fhReturn);
            }
            getTimes();
      }, [])

    return (
        <>
            <Header>Summary</Header>
            <Content>
                <InfoRow>
                    <div>
                        <InfoHeader>Vehicle selected:</InfoHeader>
                    </div>
                    <div>
                        <InfoText>{mhname}</InfoText>
                    </div>
                </InfoRow>
                <InfoRow>
                    <div>
                        <InfoHeader>Collection date</InfoHeader>
                        <InfoText>{collectionDate}</InfoText>
                    </div>
                    <div>
                        <InfoHeader>Return date</InfoHeader>
                        <InfoText>{returnDate}</InfoText>
                    </div>
                </InfoRow>
                <InfoRow>
                    <div>
                        <InfoHeader>Number of nights</InfoHeader>
                    </div>
                    <div>
                        <InfoText>{days > 2 && days - 1 + " nights"}</InfoText>
                    </div>
                </InfoRow>
                <InfoLine />
                <InfoRow>
                    <div>
                        <InfoHeader>Optional Extras</InfoHeader>
                    </div>
                    <div>
                        {optionalExtras && optionalExtras.filter(oe => oe.added).length > 0 ?
                            optionalExtras.filter(oe => oe.added).map((optionalExtra: OptionalExtraType) => {
                                return (
                                    <div key={optionalExtra.optional_extra_id}>
                                        <InfoText>{optionalExtra.optional_extra_description}</InfoText>
                                        {optionalExtra.daily &&
                                            <InfoText>({days + " days"})</InfoText>
                                        }
                                    </div>
                                    
                                );
                            }) :
                            <InfoText>None</InfoText>
                        }
                    </div>
                </InfoRow>
                <InfoLine />
                <InfoRow>
                    <div>
                        <InfoHeader>Total cost</InfoHeader>
                        {discountPercentage > 0 && <InfoHeader>{discountPercentage}% Discount</InfoHeader>}
                    </div>
                    <div>
                        <InfoText>{selectedDates.length > 1 && ConvertToPounds(totalCost)}</InfoText>
                    </div>
                </InfoRow>
                <InfoLine />
                <InfoRow>
                    <div>
                        <InfoHeader>Collection Times: {collectionTime}</InfoHeader>
                        <InfoHeader>Return Time: {returnTime}</InfoHeader>
                    </div>
                </InfoRow>
            </Content>
            {currentBooking?.tandc &&
                <>
                    <Link href={currentBooking?.tandc} target="_blank">View Booking Terms and Conditions</Link>
                    <CheckBoxContainer>
                        <CheckBoxField 
                            name="terms_conds_check" 
                            label={`I declare I am a permanent member of staff with ${currentEmployee?.employer_name}. I have read and agree to the Booking Terms and Conditions of this hire scheme. I understand that this vehicle hire is for my personal use only, I will be with the vehicle for the duration of my booking and any additional charges may be deducted from my salary.`} 
                            required={true} 
                        />
                    </CheckBoxContainer>
                </>
            }
        </>

    );
}
export default BookingSummary;
